<div class="field">
  <div class="field__label">
    {{ label }}
  </div>
  <div class="dates__wrap">
    <ng-container *ngIf="startDate !== undefined && endDate !== undefined">
      <ui-dates-with-divider
        [startDate]="startDate"
        [endDate]="endDate"
        [arrivalDeviation]="arrivalDeviation"
        [departureDeviation]="departureDeviation"
        [showWarningIcon]="showWarningIcon"
        [warningMessage]="warningMessage"
      ></ui-dates-with-divider>
    </ng-container>
    <ng-content></ng-content>
    <span *ngIf="transitTime" class="tw-ml-10">
      {{ 'common.field.totalTransit' | translate }}: {{ transitTime }}
      <span *ngIf="transitDeviation">({{ transitDeviation }})</span>
    </span>
  </div>
</div>
